import { PayloadAction } from '@reduxjs/toolkit';
import { put, select, takeLatest } from 'redux-saga/effects';
import { SpaceTabId } from 'api/models';
import { SpaceTab } from 'api/space/space-tab';
import { addSpaceTabsToSpace, Space } from 'data/spaces';
import { getSpaceByIdSelector } from 'data/spaces/selectors';
import { rlNavigation } from 'utils/navigation';
import { getSpaceTabDetailUrl } from 'utils/urls';
import { createSpaceTabSuccessSagaAction } from '../actions';
import { createSuccess } from '../index';

function* createSpaceTabSuccessSaga(action: PayloadAction<SpaceTab>) {
  const { payload: response } = action;
  const {
    space: { spaceId },
  } = response;

  yield put(
    addSpaceTabsToSpace({
      spaceId,
      spaceTabs: [response.spaceTabId].map(String),
    }),
  );
  yield put(createSuccess(response));

  const space = (yield select(
    getSpaceByIdSelector(response.space.spaceId),
  )) as Space;

  yield rlNavigation.push(
    getSpaceTabDetailUrl(
      SpaceTabId<number>(space.project, spaceId, response.spaceTabId),
    ),
  );
}

export function* watchCreateSpaceTabSuccessSaga(): Generator {
  yield takeLatest(
    createSpaceTabSuccessSagaAction.type,
    createSpaceTabSuccessSaga,
  );
}
